module.exports = __webpack_public_path__ + "static/media/cor.9c136306.jpeg";